"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameUniqueness = exports.Uniqueness = exports.Consumable = exports.Telemetry = exports.TelemetrySendingRule = exports.TelemetrySendingStyle = exports.TelemetryType = exports.Reaction = exports.ReactionKind = exports.Config = exports.Primitive = exports.Command = exports.CommandDirection = exports.CommandType = exports.Alarm = exports.AlarmSendingStyle = exports.AlarmSeverity = exports.Roles = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const entity_1 = require("../../../../../../entity");
const Device = __importStar(require("../../../../../device"));
const User = __importStar(require("../../../../../user"));
const Common = __importStar(require("../common"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.System.Schema';
/*
 * The system catalogues (`controllers/v2/system/*.js`): definitions of
 * alarms, commands, configs, reactions and telemetry a device model may use,
 * stored as JSON documents by `db/repositories/<name>repository.js`. The
 * stored shape is what the repository `create()` writes plus the timestamps
 * `JsonRepository.save()` adds.
 */
/** Roles a catalogue entry is visible to. */
exports.Roles = effect_1.Schema.Array(User.GlobalUserRole).annotations({
    identifier: `${exports.NAMESPACE}.Roles`,
    title: 'Roles',
    description: 'User roles the entry applies to',
});
const timestamps = entity_1.BaseTimestampedEntity.fields;
exports.AlarmSeverity = effect_1.Schema.Literal('critical', 'non-critical').annotations({
    identifier: `${exports.NAMESPACE}.AlarmSeverity`,
});
exports.AlarmSendingStyle = effect_1.Schema.Literal('immediate', 'stored').annotations({
    identifier: `${exports.NAMESPACE}.AlarmSendingStyle`,
    description: 'How the alarm is propagated',
});
exports.Alarm = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    description: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    parameters: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'Whether the alarm carries parameters',
    }),
    payloadExample: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Example payload, when `parameters` is true',
    }),
    role: exports.Roles,
    sendingStyle: exports.AlarmSendingStyle,
    severity: exports.AlarmSeverity,
    ...timestamps,
}).annotations({
    identifier: `${exports.NAMESPACE}.Alarm`,
    title: 'Alarm definition',
    description: 'An alarm or alert a device model may raise',
});
exports.CommandType = effect_1.Schema.Literal('noParams', 'paramsWithConfig', 'paramsWithoutConfig').annotations({
    identifier: `${exports.NAMESPACE}.CommandType`,
});
exports.CommandDirection = effect_1.Schema.Literal('D2C', 'C2D').annotations({
    identifier: `${exports.NAMESPACE}.CommandDirection`,
    description: 'Device-to-cloud or cloud-to-device',
});
exports.Command = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    description: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    mandatory: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'Whether every device must support the command',
    }),
    parameters: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'Whether the command carries parameters',
    }),
    direction: exports.CommandDirection,
    role: exports.Roles,
    payloadExample: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Example payload to send to the device, when `parameters` is true',
    }),
    jsonSchema: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'JSON Schema validating the command payload, for `paramsWithConfig`',
    }),
    type: exports.CommandType,
    ...timestamps,
}).annotations({
    identifier: `${exports.NAMESPACE}.Command`,
    title: 'Command definition',
    description: 'A command a device model accepts or emits',
});
exports.Primitive = effect_1.Schema.Literal('boolean', 'number', 'string').annotations({
    identifier: `${exports.NAMESPACE}.Primitive`,
});
exports.Config = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    description: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    editable: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
    role: exports.Roles,
    type: exports.Primitive,
    string: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Allowed values, for `string` configs',
    }),
    fullRangeMin: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    fullRangeMax: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    safeRangeMin: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    safeRangeMax: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    ...timestamps,
}).annotations({
    identifier: `${exports.NAMESPACE}.Config`,
    title: 'Config definition',
    description: 'A configuration parameter a device model exposes; ranges apply to `number` configs',
});
exports.ReactionKind = effect_1.Schema.Literal('email', 'sms', 'pushNotification', 'webhook').annotations({
    identifier: `${exports.NAMESPACE}.ReactionKind`,
});
exports.Reaction = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    description: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    kind: exports.ReactionKind,
    destination: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Where the reaction is delivered',
    }),
    ...timestamps,
}).annotations({
    identifier: `${exports.NAMESPACE}.Reaction`,
    title: 'Reaction definition',
    description: 'A notification channel definition',
});
exports.TelemetryType = effect_1.Schema.Literal('inferred', 'native').annotations({
    identifier: `${exports.NAMESPACE}.TelemetryType`,
});
exports.TelemetrySendingStyle = effect_1.Schema.Literal('always', 'onchange', 'onthreshold', 'ondelta').annotations({
    identifier: `${exports.NAMESPACE}.TelemetrySendingStyle`,
});
exports.TelemetrySendingRule = effect_1.Schema.Literal('less', 'greater').annotations({
    identifier: `${exports.NAMESPACE}.TelemetrySendingRule`,
});
exports.Telemetry = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.NonEmptyString,
    description: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    type: exports.TelemetryType,
    primitive: effect_1.Schema.propertySignature(exports.Primitive).annotations({
        description: 'Type of the values the device sends',
    }),
    unitOfMeasure: effect_1.Schema.String,
    sendingStyle: exports.TelemetrySendingStyle,
    sendingRule: effect_1.Schema.optionalWith(exports.TelemetrySendingRule, { exact: true }).annotations({
        description: 'Comparison applied by `onthreshold`',
    }),
    value: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }).annotations({
        description: 'Threshold or delta the sending style compares against',
    }),
    role: exports.Roles,
    triageRangeMin: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    triageRangeMax: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    triageExpectedValue: effect_1.Schema.optionalWith(effect_1.Schema.Union(effect_1.Schema.Boolean, effect_1.Schema.String), { exact: true }),
    alertIntegration: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }).annotations({
        description: 'Whether an alarm is attached to the telemetry',
    }),
    tags: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Tags grouping related telemetry',
    }),
    ...timestamps,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
    title: 'Telemetry definition',
    description: 'A telemetry a device model reports',
});
/*
 * `db/repositories/consumablerepository.js`: a static catalogue derived from
 * the domain consumable definitions, in the legacy document shape.
 */
exports.Consumable = effect_1.Schema.Struct({
    id: Device.Capability.Consumable.Definition.Id,
    name: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'The definition label' }),
    description: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'The definition description, `-` when none',
    }),
    kind: Common.ConsumableCategory,
    type: effect_1.Schema.Literal('default'),
    partitionKey: effect_1.Schema.Literal('default'),
    ...timestamps,
}).annotations({
    identifier: `${exports.NAMESPACE}.Consumable`,
    title: 'Consumable',
    description: 'A consumable definition in the legacy catalogue shape',
});
/** `GET .../unique` result: a key is present only when it was asked for; `true` means unused. */
exports.Uniqueness = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }).annotations({
        description: 'Whether no entry has that id',
    }),
    name: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }).annotations({
        description: 'Whether no entry has that name',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Uniqueness`,
    title: 'Uniqueness',
});
exports.NameUniqueness = effect_1.Schema.Struct({
    name: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'Whether no entry has that name',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.NameUniqueness`,
    title: 'Name uniqueness',
});
//# sourceMappingURL=schema.js.map